import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { BaseTaskListComponent } from '../base-task-list/base-task-list.component';
import { PayrollTaskSearchConfig } from '../../../models/task';
import { AuthService } from '../../../services/auth.service';
import { AclService } from '../../../services/acl.service';
import { CamelCaseToTitleCasePipe } from '../../../pipes/camel-case-to-title-case.pipe';
import { Router, UrlTree } from '@angular/router';
import { Task } from '../../../models/task';
import { PayrollService } from '../../../services/payroll.service';
import { PayTypes } from '../../../models/payroll';

@Component({
  selector: 'payroll-task-list',
  templateUrl: './payroll-task-list.component.html',
  styleUrls: ['./payroll-task-list.component.css'],
  standalone: false
})
export class PayrollTaskListComponent extends BaseTaskListComponent implements AfterViewInit {
  @Input() searchConfig: PayrollTaskSearchConfig;
  @Output() onSetTaskContainer: EventEmitter<ElementRef> = new EventEmitter();
  @ViewChild('payrollTaskContainer') payrollTaskContainer: ElementRef;

  constructor(
    public aclService: AclService,
    public authService: AuthService,
    public camelToTitleCasePipe: CamelCaseToTitleCasePipe,
    public router: Router,
    public payrollSvc: PayrollService,
    @Inject('env') private env: any
  ) {
    super(authService, camelToTitleCasePipe);
  }

  ngAfterViewInit(): void {
    // pass the container's element ref to the parent
    // so scroll can be reset on task view change
    this.onSetTaskContainer.emit(this.payrollTaskContainer);
  }

  public goToTask(task: Task) {
    const baseUrl = this.env.siteUrlRoot;

    this.payrollSvc.getPayrollStartData(task.ClientCode, true).subscribe(data => {
      const payroll = data.ActivePayroll;

      let urlTree: UrlTree = null;

      switch (task.Type) {
        case 'Payroll': {
          if (payroll != null && payroll.PayType != PayTypes.Regular) {
            break;
          }

          let queryParams = {};
          if (task.CalendarId) {
            queryParams = { calendar_id: task.CalendarId };
          }

          urlTree = this.router.createUrlTree([`/client/${task.ClientCode}/manual-checks`], {
            queryParams: queryParams
          });
          break;
        }
        case 'Correction Payroll':
        case 'Adjustment Payroll': {
          // intentional fall through
          // intentionally blank, we don't have a resume page for this, so just land on the hub
          break;
        }
        case 'Off-Cycle Payroll': {
          if (payroll != null && payroll.PayType != PayTypes.OffCycle) {
            break;
          }

          const queryParams = {
            payType: 3
          };

          urlTree = this.router.createUrlTree([`/client/${task.ClientCode}/payroll`], {
            queryParams: queryParams
          });
          break;
        }
      }

      if (urlTree == null) {
        urlTree = this.router.createUrlTree([`/client/${task.ClientCode}/payroll-landing`]);
      }

      const url = this.router.serializeUrl(urlTree);

      window.open(`${baseUrl}${url}`, '_blank');
    });
  }
}
